module.exports = __webpack_public_path__ + "img/filter-date.fdb1bb82.svg";